
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface RebuildLegalEntityRequest {
    legalEntityId: string;
}

/**
 * 
 */
export class LegalEntityAdminApi extends runtime.BaseAPI {

    /**
     * Reindex all legal entity views (technical support endpoint)
          */
    async rebuildAllLegalEntitiesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-entities/rebuildAll`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Reindex all legal entity views (technical support endpoint)
          */
    async rebuildAllLegalEntities(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.rebuildAllLegalEntitiesRaw(initOverrides);
    }

    /**
     * rebuilds a single legal entity view (technical support endpoint)
          */
    async rebuildLegalEntityRaw(requestParameters: RebuildLegalEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling rebuildLegalEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-entities/{legalEntityId}/rebuild`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * rebuilds a single legal entity view (technical support endpoint)
          */
    async rebuildLegalEntity(requestParameters: RebuildLegalEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.rebuildLegalEntityRaw(requestParameters, initOverrides);
    }

}
